import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';
import { theme } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from '../components/progress.js';

function SearchClient(props) {
  const [client, setClient] = useState(null);
  const [search, setSearch] = useState(null);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    fetchClients();
  }, [search]);

  const fetchClients = () => {
    if(search && search.length > 3){
      setLoading(true);
      axios.get(global.config.api_server+'clients?q='+search+'&limit=5&token='+localStorage.getItem("token"))
      .then(res => {
        if(res.status === 200){
          setLoading(false);
          const clients = res.data.clients;
          if(clients === null || clients === undefined){
            alertService.error("Error fetching clients");
          }else{
            setClients(clients);
          }
        }
      }).catch(err => {
          setLoading(false);
          alertService.error(err);
      });
    }
  }

  const updateClient = (id) =>{
    for(let i = 0;i < clients.length;i++){
        if(clients[i].client_id == id){
            setClient(clients[i]);
            props.handleSubmit(clients[i]);
            break;
        }
    }
  }
  
  return(
      <div className="row">
          <div className="col-md-6">
              <div className="form-group">
                  <label>Search Client</label>
                  <input type="text" maxLength="15" value={search} className="form-control" placeholder="Search Client" onChange={(e) => setSearch(e.target.value)}/>
                  {client &&
                    <div>
                    <hr/>
                    <label>Selected Client</label>
                    <input type="text" disabled={true}  className="form-control" value={client.client_id + " | " + client.email + " | " + client.mobile}/>
                    </div>
                  }
              </div>
          </div>
          <div className="col-md-6">
          {clients.map(itrClient =>
              <div className={'card clip-card clip-card-'+theme() + (client && client.client_id === itrClient.client_id ? ' selected' : '')} key={itrClient.client_id} onClick={(e) => updateClient(itrClient.client_id)}>
                  <div class="card-body">
                    <p class="card-text">{itrClient.first_name} {itrClient.middle_name} {itrClient.last_name} ({itrClient.email} | {itrClient.mobile})</p>
                  </div>
              </div>
          )}
          </div>
          <div className="col-md-12">
            {loading &&
              <Progress/>
            }
            <hr/>
          </div>
      </div>
  )
}

export default SearchClient;